module.exports = __webpack_public_path__ + "static/media/wallet_pass.6953efb8.png";